import React from 'react'
import { Container, Typography, Box, Divider } from '@mui/material'
import styles from './PrivacyAndPolicy.module.scss'
import { FaBold } from 'react-icons/fa6'

const PrivacyAndPolicy = () => {
  return (
    <Container className={styles.privacyContainer}>

      <Box className={styles.header} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography sx={{ fontSize: 20, color: '#1d3d40' }}>
          <b>Meta Privacy Policy – OTUSONE LLP</b>
        </Typography>
        <Typography sx={{ color: 'gray' }}>
          Effective Date: 01-07-2025
        </Typography>
      </Box>


      <Typography className={styles.paragraph}>
        At <strong>OTUSONE LLP</strong>, we value your privacy and are committed to protecting your personal
        information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information
        when you interact with our website, products, and services, including WhatsApp Business communication.
      </Typography>

      <Divider className={styles.divider} />

      <Box className={styles.section}>
        <Typography sx={{ color: '#1d3d40' }}><b>1. Information We Collect</b></Typography>
        <ul className={styles.list}>
          <li><strong>Personal Information:</strong> Name, email, phone number, company details, and billing information.</li>
          <li><strong>Technical Information:</strong> IP address, browser type, device information, and cookies.</li>
          <li><strong>Communication Data:</strong> Messages or inquiries via website, email, or WhatsApp Business API.</li>
        </ul>
      </Box>

      <Box className={styles.section}>
        <Typography sx={{ color: '#1d3d40' }}><b>2. How We Use Your Information</b></Typography>
        <ul className={styles.list}>
          <li>Provide and improve our IT services and solutions.</li>
          <li>Communicate with you regarding inquiries, projects, or updates.</li>
          <li>Send service-related notifications via email, phone, or WhatsApp (with your consent).</li>
          <li>Comply with legal and regulatory obligations.</li>
        </ul>
      </Box>

      <Box className={styles.section}>
        <Typography sx={{ color: '#1d3d40' }}><b>3. Data Sharing & Disclosure</b></Typography>
        <ul className={styles.list}>
          <li>We do not sell your data to third parties.</li>
          <li>We may share information with trusted partners, vendors, or service providers (e.g., payment gateways, hosting providers).</li>
          <li>Information may be disclosed to comply with applicable law, regulations, or legal processes.</li>
        </ul>
      </Box>

      <Box className={styles.section}>
        <Typography sx={{ color: '#1d3d40' }}><b>4. Data Security</b></Typography>
        <Typography className={styles.paragraph}>
          We implement reasonable administrative, technical, and organizational measures to safeguard your
          information. However, no method of transmission or storage is 100% secure.
        </Typography>
      </Box>

      <Box className={styles.section}>
        <Typography sx={{ color: '#1d3d40' }}><b>5. Cookies & Tracking</b></Typography>
        <Typography className={styles.paragraph}>
          Our website may use cookies and similar technologies to enhance user experience, analyze trends,
          and improve performance. You may disable cookies via your browser settings.
        </Typography>
      </Box>

      <Box className={styles.section}>
        <Typography sx={{ color: '#1d3d40' }}><b>6. Your Rights</b></Typography>
        <ul className={styles.list}>
          <li>Access, correct, or delete your personal data.</li>
          <li>Opt out of marketing communications.</li>
          <li>Withdraw consent for data processing.</li>
        </ul>
      </Box>

      <Box className={styles.section}>
        <Typography sx={{ color: '#1d3d40' }}><b>7. Contact Us</b></Typography>
        <Typography className={styles.paragraph}>
          If you have any questions about this Privacy Policy, contact us at:
        </Typography>
        <Box className={styles.contactBox}>
          <Typography><span className={styles.label}>Email:</span> <a href="mailto:info@otusone.com">info@otusone.com</a></Typography>
          <Typography><span className={styles.label}>Phone:</span> +91 9340312713</Typography>
          <Typography><span className={styles.label}>Address:</span> G-903, Ace City, Greater Noida West, Sector 01, 201306</Typography>
          <Typography><span className={styles.label}>Office address:</span> H-112, sector 63, Noida, 201301</Typography>
        </Box>
      </Box>
    </Container>
  )
}

export default PrivacyAndPolicy